import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import Tooltip from '@material-ui/core/Tooltip'
import {IConfigFieldDefinition} from '../../services/configurations-areas/fields-definitions/config-field-definition-base';

export interface FieldDescriptionComponentProps {
    field: IConfigFieldDefinition;
}

export class ConfigurationFieldTooltipComponent extends LauncherComponentBase<FieldDescriptionComponentProps> {
    render() {
        if(!this.props.field.description) {
            return this.props.field.render();
        }
        return (
            <Tooltip title={`${this.props.field.title}: ${this.props.field.description}`} arrow>
                <div>{this.props.field.render()}</div>
            </Tooltip>
        );
    }
}